module.exports = __webpack_public_path__ + "static/move_fastest-449875cd5187866e2815c84d08434035.jpg";